/**
 * JavaScript Utility - valueFrom
 * @author 서명환 <mhseo@ulalalab.com>
 */
import isEmpty from './isEmpty';

function valueFrom(value, defaultValue, isAllowBlank) {
  return isEmpty(value, isAllowBlank) ? defaultValue : value;
}

export default valueFrom;
